/**
 * @generated SignedSource<<823bfa84c86a43a9659a1a116ab0ff6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FloatingRecordingControls_note$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"AskFellowHooks_useAskFellowButton_note" | "PreMeetingControls_note">;
  readonly " $fragmentType": "FloatingRecordingControls_note";
};
export type FloatingRecordingControls_note$key = {
  readonly " $data"?: FloatingRecordingControls_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"FloatingRecordingControls_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FloatingRecordingControls_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PreMeetingControls_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AskFellowHooks_useAskFellowButton_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "e7e265dd619a78e1dfdd7e7c53be5fcc";

export default node;
